export default __webpack_public_path__ + "static/media/pharmassess.2025c8de.png";